// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
	  apiKey: "AIzaSyAeP68dJ1s0UtlCj2FOl0jyfc8B-UyexjQ",
	  authDomain: "csc2020election.firebaseapp.com",
	  projectId: "csc2020election",
	  storageBucket: "csc2020election.appspot.com",
	  messagingSenderId: "1038847999880",
	  appId: "1:1038847999880:web:abc140a5ab1193df30843d"
	}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
